import React from "react";
import { Link } from "react-router-dom";
import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		height: "100vh",
	},
}));

const NotFound = () => {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<h1>404 - Not Found!</h1>
			<Button component={Link} to="/" variant="contained" color="primary">
				Go Home
			</Button>
		</div>
	);
};

export default NotFound;
